import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Poi, PoiType } from './types/Poi';

interface GetPoisQuery {
  type: PoiType;
  // One of countryCode/query/latlng/geonameId is required
  countryCode?: string;
  query?: string;
  latitude?: number;
  longitude?: number;
  radius?: number;
  geonameId?: number;
  singleGeoname?: boolean;
  allInCountry?: boolean;
  limit?: number;
  offset?: number;
}

interface PoisResponse {
  pois: Poi[];
  count: number;
}

export type GetPoisCall = (
  data: GetPoisQuery,
) => Promise<{ data: PoisResponse }>;

export default (makeCall: MakeCall) => (query: GetPoisQuery) =>
  makeCall<PoisResponse>('GET', `/api/v2/pois`, { query });
